import React, { useState, useEffect } from "react";
import {
   Grid,
   Box,
   TextField,
   Typography,
   MenuItem,
   Button,
   Divider,
} from "@mui/material";
import ApexChart from "react-apexcharts";
import { GetQuotaChartData } from "./defineSlice";
import { useSelector, useDispatch } from "react-redux";

function DefineQuotaChart() {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { quotaChartColors, quotaChartLabelNames, quotaChartSeriesData, showChart } =
      define;
   const options = {
      chart: {
         zoom: {
            enabled: true,
         },
         animations: {
            enabled: false,
         },
         toolbar: {
            show: false,
         },
      },
      tooltip: {
         y: {
           formatter: (value) => {
             const formatter = new Intl.NumberFormat("en-US");
             return formatter.format(value);
           },
         },
       },
      grid: {
         show: false,
      },
      labels: quotaChartLabelNames,
      series: {
         type: "scatter",
      },
      yaxis: {
         labels: {
           formatter: (value) => {
             const formatter = new Intl.NumberFormat("en-US");
             return formatter.format(value);
           },
         },
      },
      colors: quotaChartColors,
      interpolateNulls: false,
      markers: {
         size: 4,
      },
      stroke: {
         width: 1,
      },
      noData: {
         text: "Loading Chart...",
         align: "center",
         verticalAlign: "middle",
         offsetX: 0,
         offsetY: 0,
         style: {
            color: "#000000",
         },
      },
   };
   return (
      <Grid container columns={12} spacing={2} sx={{ display: showChart ? "block" : "none" }}>
         <Grid item xs={12}>
            <Box className={"DefineQuotaChart"}>
               <ApexChart
                  options={options}
                  series={quotaChartSeriesData}
                  type="line"
                  height={400}
                  width={"100%"}
               />
            </Box>
         </Grid>
      </Grid>
   );
}

export default DefineQuotaChart;
